import { Component } from '@angular/core';
import { ModalController,NavController, NavParams,LoadingController } from 'ionic-angular';
import {SummaryServiceProvider} from '../../../../providers/wh/summary-service';

@Component({
  selector: 'summary-board',
  templateUrl: '../../overall/summary/index.html',
  providers: [SummaryServiceProvider]
})
export class DvSummaryPage {
 header_data:any;

  d: any; r: string;
  div_:any;

pet:any;
dashboard_data:any="";
  public drivers_list: any;
  objectKeys = Object.keys;
  constructor(public modalCtrl: ModalController,public navCtrl: NavController, public navParams: NavParams,public summaryService: SummaryServiceProvider,public loadingCtrl: LoadingController) {
   


    this.header_data={ismenu:true,ishome:false,title:"Drivers Summary",parentReloadData:d=>{this.load_dashboard_data(true)}};
   
    this.load_dashboard_data(true);
        this.div_=[];

  }


changeDriver(a,i,dashboard_data){
  console.log(a);
  a.driver_id=i;
  a.dashboard_data=dashboard_data;
 // a.parentPage=this;

   let profileModal = this.modalCtrl.create('ModalPage',{
        a,
        parentReloadData: d => {
            this.load_dashboard_data(false);
        }
    });
   profileModal.present();

}


  load_dashboard_data(show_loader)
  {
 
 if(show_loader)
 {
  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();

        this.summaryService.load_driver_summary()
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);
           this.pet = "0";
        });
    
      loader.dismiss();
    }
    else{
         this.summaryService.load_driver_summary()
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);
           this.pet = "0";
        });
    }

  }
  


}



// WEBPACK FOOTER //
// ./src/pages/backoffice/driver/summary/index.ts